import React from "react";

const Notfoundpage = () => {
    return (
        <h4>Notfound</h4>
    )
}

export default Notfoundpage;